import { cn } from '@/lib/utils';
import { MoviePoster } from '@/types/movie-poster';
import { dataTestTransformer } from '@/utils/data-test-helper';
import { normalizeMediaFileUrl } from '@/utils/media-file-url';
import Image from 'next/image';
import { CinemarkLink } from '../cinemark-link/cinemark-link';

type MovieItemComponentProps = {
  className?: string;
  dataLinkCategory: string;
  dataLinkName?: string;
  href?: string;
  movie: MoviePoster;
};

export const MovieItemComponent = ({ className, dataLinkCategory, dataLinkName, href, movie }: MovieItemComponentProps): React.JSX.Element => {
  return (
    <CinemarkLink useAnchor
      dataLinkCategory={dataLinkCategory}
      dataLinkName={dataLinkName ?? `Movie - ${movie.movieTitle}`}
      dataTest={`link-movie-${movie.movieTitle ? dataTestTransformer(movie.movieTitle) : movie.movieId}`}
      href={href ?? movie.movieUrl}
    >
      <Image alt={movie.moviePosterAlt || `${movie.movieTitle} poster`}
        className={cn('min-w-14 w-full h-auto object-cover aspect-2/3 rounded-lg', className)}
        height={375}
        src={normalizeMediaFileUrl(movie.moviePosterUrl) || '/img/poster_blank.jpg'}
        width={250}
      />
    </CinemarkLink>
  );
};
